<div class="login-container">
    <div class="login-background-shape login-background-shape-one"></div>
    <div class="login-background-shape login-background-shape-two"></div>

    <div class="login-form-container">
        <section class="login-form-inner-container" aria-label="Acceso a EamOne">
            <div class="login-form-data">
                <header class="login-form-header">
                    <img src="assets/svgs/eamoneLogo.svg" class="login-form-logo" alt="EamOne">
                    <app-language-switcher></app-language-switcher>
                </header>

                <div class="login-form-copy">
                    <h1>{{t?.loginbienvenido || 'Bienvenido'}}</h1>
                    <p>{{t?.loginsubtitulo || 'Ingresa con tu usuario y contraseña.'}}</p>
                </div>

                <div class="alert alert-danger login-alert" *ngIf="errorMsg">
                    {{errorMsg}}
                </div>

                <form [formGroup]="loginForm" (submit)="onSubmit()" class="login-form">
                    <div class="login-form-group">
                        <label for="nombre">{{t?.usuario || 'Usuario'}}</label>
                        <input id="nombre" class="form-control" placeholder="{{t?.usuario || 'Usuario'}}" type="Text" formControlName="nombre" required>
                    </div>

                    <div class="login-form-group">
                        <label for="password">{{t?.contrasena || 'Contrasena'}}</label>
                        <input type="Password" class="form-control" placeholder="{{t?.contrasena || 'Contrasena'}}" id="password" formControlName="password" required>
                    </div>

                    <div class="login-form-group-btn">
                        <button type="submit" class="login-submit-btn" [disabled]="!loginForm.valid">
                            <span>{{t?.ingresar || 'Ingresar'}}</span>
                            <span class="login-submit-icon" aria-hidden="true">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                        </button>
                    </div>
                </form>

                <footer class="login-form-footer">
                    <div class="integrated-with-sapb1">
                        <span class="integrated-with-label">{{t?.loginintegradocon || 'Integrado con'}}</span>
                        <span class="integrated-with-divider" aria-hidden="true"></span>
                        <img src="assets/svgs/SAPB1-Logo.svg" alt="SAP Business One">
                    </div>
                    <small>{{t?.logincopyright || 'Copyright@ 2020 OilOne. Todos los derechos reservados'}}</small>
                </footer>
            </div>

            <aside class="login-form-image" aria-label="Imagen industrial">
                <img src="assets/images/trabajador-login.png" class="img-fluid" alt="Operación industrial">
            </aside>
        </section>
    </div>
</div>
